// DEPRECATED all new development should use tabbed-dashboard
import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import CommonDialog from '../../modal-dialog/common-dialog/common-dialog';
import DashboardCommon from '../../../app/data-framework/dashboard-common';
import PermissionService from '../../../services/permission.service';
import Signals from 'signals';
import templateMarkup from 'raw-loader!./tabbeddashboards-widget.html';
import LoginService from "../../../services/login.service";
import DataProvider from "../../../app/data-framework/data-provider";

function TabbeddashboardsWidget(params) {
    var self = this;
    self.initialize(params);

    // Methods - Added in the constructor so that they can retain their execution context. These are used
    // in the knockout:foreach context so the "this" reference is reassigned or they're used as callbacks.
    // To preserve that we use the "self" pattern and a closure.
    self.activateTabClick = function (data, event) {
        self.activeTabId(data.id);
        self.activateTab(data);
    };

    self.activateTab = function (data, replace) {
        var route = ko.unwrap(self.route);
        var request = route.request_;
        let url = buildHref(request, data.id);
        if (replace === true) {
            window.location.replace(url);
        } else {
            window.location.href = url;
        }
    };

    self.buildTabHref = function(id) {
        var route = ko.unwrap(self.route);
        var request = route.request_;
        return buildHref(request, id);
    }

    // this function is invoked by AddPanels modal dialog when a panel is added
    self.addPanelCallback = function (panelTemplateObj, panelOptions) {
        var panel = self.dashboardCommon.CreatePanelFromTemplate(panelTemplateObj, panelOptions);
        var obsParamsList = self.dashboardCommon.makeObservableParams(panel);

        let dataHandle = self.dashboardCommon.Register(panel, obsParamsList);

        var component = self.dashboardCommon.GetComponent(panel, dataHandle);
        component.params.observableParamsList = obsParamsList;
        component.params.viewLevelOptions = self.viewLevelOptions;
        self.dashboardCommon.AddComponentToActiveDashboard(component);
    };

    self.addTab = function () {
        if (ko.unwrap(self.allowNewTab)) {
            // disable adding another tab until adding this new tab is complete
            self.allowNewTab(false);
            self.dashboardCommon
                .addNewTab(ko.unwrap(self.tabsList))
                .then(function (newTabId) {
                    self.dashboardCommon
                        .GetTabsList()
                        .then(function (tabsList) {
                            self.tabsList(tabsList);
                            self.activateTab({ id: newTabId });
                        });
                })
                .catch(function () {
                    alert('There was an error while adding a new tab.');
                })
                .finally(function() {
                    // re-enable adding new tab
                    self.allowNewTab(true);
                });
        }
    };

    self.deleteCurrentTab = function () {
        var prompt = 'Deleting this tab will remove all panels contained within. Do you wish to proceed?';
        CommonDialog
            .confirm(prompt)
            .then(function (confirmed) {
                if (confirmed) {
                    self.dashboardCommon
                        .deleteTab(ko.unwrap(self.activeTabId))
                        .then(function () {
                            self.dashboardCommon
                                .GetTabsList()
                                .then(function (tabsList) {
                                    self.tabsList(tabsList);
                                    self.activateTab(_.first(tabsList), true);
                                });
                        });
                }
            });
    };
    // end-methods

    // Call loadDashboard at the very end since it depends on some of the methods defined above.
    // UI-1380 moved to koDescendantsComplete
    // moved back here due to bug in tko https://github.com/knockout/tko/commit/6f94126246988793a09239c1dde30a380cf20b74
    self.loadDashboard();
}

TabbeddashboardsWidget.prototype = {
    initialize: function (params) {
        var self = this;

        self.subscriptions = [];
        self.widgetDragDropContainerOptions = {};

        self.appId = params.appId;
        self.viewId = params.viewId;
        self.route = params.route;
        self.dataProvider = DataProvider.getInstance();
        self.permissionService = new PermissionService(LoginService.userObject);
        self.fixedPanelOnlyTabs = params.fixedPanelOnlyTabs || [];
        self.hiddenTabs = params.hiddenTabs || [];
        self.showTabs = _.isNil(params.showTabs) || params.showTabs;
        self.viewLevelOptions = params.viewLevelOptions;
        self.allowNewTab = ko.observable(!!params.allowNewTab);
        self.disallowTabEditing = ko.observable(!!params.disallowTabEditing);

        self.link = ko.pureComputed(function () {
            var route = ko.unwrap(self.route);
            return route.link;
        });

        self.activeTabId = ko.observable(self.route().tabId || 0);
        self.currentPanelsObservable = ko.observableArray([]);
        self.currentTabFixedPanelObservable = ko.observableArray([]);
        self.fixedComponent = ko.observable();
        self.hasfixedComponent = ko.observable(true);
        self.tabsList = ko.observableArray([]);


        self.showTabsList = ko.pureComputed(function () {
            return self.tabsList() && self.tabsList().length > 1;
            // return true;
        });

        self.showAddDashboard = ko.pureComputed(function () {
            return self.allowNewTab() && self.permissionService.hasPermission(self.permissionService.DashboardEditPermission);
        });



        self.dashboardCommon = new DashboardCommon(
            self.dataProvider, self.appId, ko.unwrap(self.viewId), self.currentPanelsObservable, self.currentTabFixedPanelObservable
        );

        self.dragDropWidgetSignals = {
            widgetPositionsChanged: new Signals.Signal()
        };
        self.dragDropWidgetSignals.widgetPositionsChanged.add(function() {
            self.dashboardCommon.saveCurrentTab();
        });

        self.myView = self.route().view;

        self.subscriptions.push(
            self.route.subscribe(function () {
                let route = ko.unwrap(self.route);
                if (route.view === self.myView) {
                    self.activeTabId(route.tabId || 0);
                }
            }),

            self.activeTabId.subscribe(function (updatedTabId) {
                self.dashboardCommon
                    .LoadTabPanels(updatedTabId, self.viewLevelOptions)
                    .then(self.setupFixedPanel.bind(self));
            })
        );
    },

    koDescendantsComplete: function (element) {
        var self = this;
        // self.loadDashboard(); // moved back to init
    },

    loadDashboard: function () {
        var self = this;
        self.dashboardCommon
            .GetTabsList()
            .then(function (tabsList) {
                self.tabsList(tabsList);
                var tab = getTab(ko.unwrap(self.activeTabId), tabsList);

                // load the active tab
                var link = ko.unwrap(self.link);
                if (link) {
                    self.dataProvider
                        .getTokenParams(link)
                        .then(function (tokenParams) {
                            self.dashboardCommon
                                .LoadTabPanels(ko.unwrap(self.activeTabId), self.viewLevelOptions, _.get(tokenParams, 'tabprefs'))
                                .then(self.setupFixedPanel.bind(self));
                        });

                } else if (_.isEmpty(tab)) {
                    // the active tab is not on the tab list, reset to first tab
                    return self.activateTab(_.first(tabsList), true);

                } else {
                    self.dashboardCommon
                        .LoadTabPanels(self.activeTabId, self.viewLevelOptions)
                        .then(self.setupFixedPanel.bind(self));
                }
            });
    },

    setupFixedPanel: function () {
        var self = this;
        var currentTabFixedPanels = ko.unwrap(self.currentTabFixedPanelObservable);
        if (!_.isEmpty(currentTabFixedPanels)) {
            self.fixedComponent(currentTabFixedPanels[0]);
            self.hasfixedComponent(true);
        }
    },

    //  UI bound function
    isHiddenTab: function (id) {
        var self = this;
        return _.includes(self.hiddenTabs, id);
    },

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose: function () {
        var self = this;
        self.dashboardCommon.dispose();
        _.forEach(self.subscriptions, function(subscription) {
            subscription.dispose();
        });
    }
};

function buildHref(currentUrl, newTabId) {
    var p = currentUrl.indexOf('/params/');
    if (p < 0) {
        p = currentUrl.indexOf('/link/');
    }
    var tabIdPath = '/tabid/' + newTabId;
    var plainUrl = p >= 0 ? currentUrl.substring(0, p) : currentUrl;
    var matchstring = plainUrl.match(/\/tabid\/[\w\d]+$/); // e.g. /tabid/j2w6cfe7
    var newurl = matchstring === null ? (plainUrl + tabIdPath) : plainUrl.replace(/\/tabid\/[\w\d]+$/, tabIdPath);
    return  "#" + newurl;
}

function getTab(tabId, tabList) {
    return _.find(tabList, function(t) {
        return String(t.id) === String(tabId);
    });
}

export default { template: templateMarkup, viewModel: TabbeddashboardsWidget };
